import http from 'utils/http';

export const reorderCategoryPosition = ({ categoryId, position }) => http.post(`v1/categories/${categoryId}/move/`, { position }).then((res) => res.data);
export const reorderGlobalCategoriesPosition = ({ menuId, categoryIds }) => http.patch(`v1/organizations/{{organizationId}}/global-menus/${menuId}/categories/`, categoryIds).then((res) => res.data);

export const createCategory = ({ name, menuId }) => http.post(
  'v1/categories/',
  { name, menu: menuId, items_positions: [0] },
).then((res) => res.data);

export const deleteCategory = (id) => http.delete(`v1/categories/${id}/`).then((res) => res.data);
export const deleteGlobalCategory = ({ menuId, categoryId }) => http.delete(`v1/organizations/{{organizationId}}/global-menus/${menuId}/categories/${categoryId}/`).then((res) => res.data);

export const editCategory = ({ id, name }) => http.patch(`v1/categories/${id}/`, { name }).then((res) => res.data);
export const changeCategoryAvailability = (id, isActive) => http.patch(`v1/categories/${id}/`, { is_active: isActive }).then((res) => res.data);
